import React, { memo, useMemo } from 'react'
import { Toggle } from '../..'

import * as styles from './styles.module.scss'
import classNames from 'classnames'
import { DescriptionToggleProps } from './types'

const DescriptionToggle = ({
   id,
   label,
   description,
   isChecked,
   onToggle,
   isDisabled,
}: DescriptionToggleProps) => {
   const labelClassName = useMemo(
      () =>
         classNames(styles.toggleLabel, {
            [styles.toggleLabelDisabled]: isDisabled,
         }),
      [isDisabled]
   )

   return (
      <>
         <div className={styles.toggleWrapper}>
            <span className={styles.toggleButton}>
               <Toggle
                  id={id}
                  size="md"
                  isChecked={isChecked}
                  onToggle={onToggle}
                  disabled={isDisabled}
               />
            </span>
            <span className={labelClassName}>{label}</span>
         </div>
         <p className={styles.toggleDescription}>{description}</p>
      </>
   )
}

export default memo(DescriptionToggle)
